// src/features/mech/plastics/questions/PartWeightDimensionsQuestion.jsx
import React from "react";
import { Box } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import PerlTextField from "../../../../shared/components/PerlTextField";

export default function PartWeightDimensionsQuestion({ value, onChange }) {
  const theme = useTheme();
  const perlColors = theme.custom?.perlColors || {
    white: "#ffffff",
    textPrimary: "#F1F2F3",
    textSecondary: "#9097A1",
  };
  const brandColor =
    theme.custom?.perlColors?.brandColor || theme.palette?.primary?.main || "#ff6034";

  // Parse the value object or initialize with empty strings
  const dimensionValue = value || {
    partLength: "",
    partThickness: "",
  };
  const finishWeightNum = parseFloat(dimensionValue.finishWeight);
  const isFinishWeightInvalid = !isNaN(finishWeightNum) && finishWeightNum > 550;
  const thicknessNum = parseFloat(dimensionValue.partThickness);
  const isThicknessInvalid = !isNaN(thicknessNum) && thicknessNum > 10;

  const handleFieldChange = (field, newValue) => {
    onChange?.({
      ...dimensionValue,
      [field]: newValue,
    });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 2 }}>
      <PerlTextField
        label="Part finish weight (g)"
        required
        type="number"
        value={dimensionValue.finishWeight || ""}
        onChange={(e) => handleFieldChange("finishWeight", e.target.value)}
        placeholder="Enter finish weight in grams"
        error={isFinishWeightInvalid}
        helperText={
          isFinishWeightInvalid
            ? "Finish weight cannot exceed 550 g"
            : "Max 550 g"
        }
        InputProps={{
          inputProps: { max: 550 },
          sx: {
            bgcolor: alpha(perlColors.white, 0.02),
            color: perlColors.textPrimary,
            fontSize: "0.9rem",
            borderRadius: 1.5,
            "& fieldset": { borderColor: alpha(perlColors.textPrimary, 0.12) },
            "&:hover fieldset": { borderColor: alpha(brandColor, 0.8) },
            "&.Mui-focused fieldset": {
              borderColor: brandColor,
              boxShadow: `0 0 0 2px ${brandColor}33`,
            },
          },
        }}
        InputLabelProps={{
          sx: {
            color: perlColors.textSecondary,
            fontSize: "0.85rem",
            letterSpacing: "0.3px",
            "&.Mui-focused": { color: perlColors.textPrimary },
          },
        }}
      />
      <PerlTextField
        label="Thickness (mm)"
        required
        type="number"
        value={dimensionValue.partThickness || ""}
        onChange={(e) => handleFieldChange("partThickness", e.target.value)}
        placeholder="Enter thickness in millimeters"
        error={isThicknessInvalid}
        helperText={
          isThicknessInvalid ? "Thickness cannot exceed 10 mm" : "Max 10 mm"
        }
        InputProps={{
          inputProps: { max: 10 },
          sx: {
            bgcolor: alpha(perlColors.white, 0.02),
            color: perlColors.textPrimary,
            fontSize: "0.9rem",
            borderRadius: 1.5,
            "& fieldset": { borderColor: alpha(perlColors.textPrimary, 0.12) },
            "&:hover fieldset": { borderColor: alpha(brandColor, 0.8) },
            "&.Mui-focused fieldset": {
              borderColor: brandColor,
              boxShadow: `0 0 0 2px ${brandColor}33`,
            },
          },
        }}
        InputLabelProps={{
          sx: {
            color: perlColors.textSecondary,
            fontSize: "0.85rem",
            letterSpacing: "0.3px",
            "&.Mui-focused": { color: perlColors.textPrimary },
          },
        }}
      />
    </Box>
  );
}

